import { render, staticRenderFns } from "./Door_sensor.vue?vue&type=template&id=5e2e28c5"
import script from "./Door_sensor.vue?vue&type=script&lang=js"
export * from "./Door_sensor.vue?vue&type=script&lang=js"
import style0 from "./Door_sensor.vue?vue&type=style&index=0&id=5e2e28c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports